/**
 * FAQ for companies (Mandanten) – Headhunting / Direktansprache im Gesundheitswesen.
 * Used on the FAQ page linked from the navbar (Für Unternehmen → FAQ).
 */
export const FAQ_FOR_COMPANIES = [
  {
    question: "Was ist Direktansprache (Headhunting) im medizinischen Bereich?",
    answer:
      "Direktansprache bedeutet, dass wir qualifizierte Fach- und Führungskräfte gezielt ansprechen, die nicht aktiv auf Jobsuche sind. Im Gesundheitswesen suchen wir z.B. Ärztinnen und Ärzte, Klinikleitungen oder Spezialisten aus Pharma und Medizintechnik und bringen sie mit passenden Arbeitgebern zusammen. Die Methode ist diskret und erlaubt eine zielgenaue Besetzung von Vakanzen.",
  },
  {
    question: "Wie lange dauert eine typische Besetzung über Headhunting?",
    answer:
      "Die Dauer hängt von der Rolle, der Verfügbarkeit passender Kandidaten und Ihrem Zeitrahmen ab. In der Regel rechnen wir mit wenigen Wochen bis mehreren Monaten vom Briefing bis zur Vertragsunterzeichnung. Bei gut abgestimmten Profilen und zügiger Abstimmung mit Ihnen kann der Prozess beschleunigt werden.",
  },
  {
    question: "Was kostet die Zusammenarbeit mit REPEXO Medical?",
    answer:
      "Unsere Honorare sind mandatsspezifisch und werden in einem persönlichen Gespräch vereinbart. Wir arbeiten in der Regel nach der Drittellösung: Ein Drittel bei Auftragserteilung, ein Drittel bei Vertragsunterzeichnung mit dem Kandidaten, ein Drittel nach erfolgreicher Probezeit. Gerne erstellen wir Ihnen ein unverbindliches Angebot nach einer kurzen Bedarfsanalyse.",
  },
  {
    question: "Arbeiten Sie auch für Kliniken, MVZ und Praxen?",
    answer:
      "Ja. Wir sind auf die Besetzung von Positionen im Health-Care-Bereich spezialisiert – von der Facharztstelle in der Klinik über die Nachfolge in der Praxis bis zu Führungsrollen in MVZ, Pharma oder Medizintechnik. Unser Fokus liegt auf Direktansprache und Executive Search für das gesamte medizinische Umfeld.",
  },
  {
    question: "Wie garantieren Sie Diskretion und Datenschutz?",
    answer:
      "Diskretion ist für uns zentral. Kandidaten werden nur mit Ihrer Zustimmung und in Absprache mit uns angesprochen. Alle Daten werden vertraulich behandelt und den geltenden datenschutzrechtlichen Anforderungen entsprechend verarbeitet. Wir informieren Kandidaten transparent über Mandant und Rolle, bevor vertiefte Gespräche geführt werden.",
  },
  {
    question: "Bieten Sie Garantien bei der Besetzung?",
    answer:
      "Ja. Wir führen vor Auftragsannahme eine Situationsanalyse und ein Briefing mit Ihnen durch und nehmen nur Mandate an, bei denen wir realistische Erfolgsaussichten sehen. Je nach Mandat vereinbaren wir Nachbesserungsgarantien und transparente Prozessschritte. Details besprechen wir individuell im Rahmen Ihres Suchauftrags.",
  },
  {
    question: "Kann ich als Arbeitgeber auch international suchen lassen?",
    answer:
      "Ja. Wir haben Zugang zu internationalen Märkten und unterstützen bei grenzüberschreitenden Suchaufträgen. Ob nationale oder internationale Suche – wir stimmen die Suchstrategie mit Ihnen ab und nutzen unser Netzwerk und unsere Erfahrung im Healthcare-Recruiting.",
  },
];
